import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useRouterProps } from '../hooks/useRouterProps';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';

/**
 * Guest route guard - redirects authenticated users away
 * Use this for login, register, and other guest-only pages
 */
const GuestRoute = ({ children, render, redirectTo = ROUTES.TEACHER.DASHBOARD.path, ...props }) => {
    const auth = useAuth();
    const routerProps = useRouterProps();

    // If authenticated, redirect away
    if (auth.isAuthenticated) {
        return <Navigate to={redirectTo} replace />;
    }

    // Not authenticated, allow access
    return render ? render({ ...props, ...routerProps }) : children;
};

export default GuestRoute;
